function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5032 14.6546L10.5028 22H14.3825V14.6546H10.5032Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7341 14.3216C23.0286 14.5428 22.2934 14.6551 21.554 14.6547H19.1568L24.1938 21.982H29L23.7341 14.3216Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87976 10.5976H0V22H3.87976V10.5976Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7329 5.30778H3.80172L0.25703 9.38287H15.133L18.7329 5.30778Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5931 0L8.46463 0.0101881L4.93757 4.02885L21.0053 4.07313C21.8685 4.07313 22.6963 4.41598 23.3067 5.02626C23.9171 5.63654 24.26 6.46426 24.26 7.32732C24.26 8.19039 23.9171 9.01811 23.3067 9.62839C22.6963 10.2387 21.8685 10.5815 21.0053 10.5815H14.0687L10.5025 14.6566H21.5931C25.6238 14.6566 28.9215 11.3593 28.9215 7.32928C28.9215 3.29925 25.6238 0 21.5931 0Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.1315 9.38287H5.25174V22H9.1315V9.38287Z",
  fill: "white"
});

function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo_3.957ad4f6.svg";
export { ForwardRef as ReactComponent };